import { post, get } from './request'
import wx from 'weixin-js-sdk'
import state from '../store/state.js'
import {Share,wxTicket_config} from '@/api/getData'
import { Notify } from 'vant';
import { isIOS } from './index.js'

// 分享配置
export function requireConfig() {
  var currentUrl = window.location.href;
  wxTicket_config({url: currentUrl}).then(res => {
      wx.config({
        debug: false, // 开启调试模式
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.nonceStr, // 必填，生成签名的随机串
        signature: res.signature,// 必填，签名
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
      });
  }).catch(err => {
    Notify({type: 'danger',message: err.message})
  })
}

//分享设置
function requireShare(madeShare) {
  if(!isIOS()) {
    requireConfig();
  }
  if (madeShare != null) {
    allotShare(madeShare);
  } else {
    //初始化默认分享
    let shareState = state;
    let typeName = "home";
    let currentUrl = window.location.href;
    let urlArr = currentUrl.split("/");
    let newArr = urlArr.slice(0);
    newArr.pop();
    let newCurrentUrl = newArr.join('/');
    let shareParam = {
      type: typeName,
      imgUrl: shareState.publicPath+ "sd_share_img.jpg" + "?" + new Date().getTime(),
      desc: "",
      title: "",
      link: newCurrentUrl + "/home?isshare=true"
    }
    allotShare(shareParam);
  }
}

function allotShare(param) {
  Share(param).then((res) => {
    let data = res.data.data;
    if (data) {
      wx.ready(function () {
        // console.log("当前defaultShare", data)
        wx.updateAppMessageShareData(data);
        wx.updateTimelineShareData(data);
        // 自定义“分享给朋友”
        wx.onMenuShareAppMessage(data);
        // 自定义“分享到朋友圈”     
        wx.onMenuShareTimeline(data);
      })
    }
  })
}




export {
  requireShare
}



// WEBPACK FOOTER //
// ./src/utils/share.js